import DemoRenderer__LegacyDemoInstructions from '@runtime/DemoRenderer';
import InterfaceRenderer__LinkInstructions from '@runtime/TypescriptMetadataRenderer/interface';
import DemoRenderer__LinkInstructions from '@runtime/DemoRenderer';
import legacyImportDemo_354296454 from "../../../../../packages/component/src/components/table/demo/demo1.js?loadDemo";
import legacyImportDemo_443464005 from "../../../../../packages/component/src/components/table/demo/demo2.js?loadDemo";
import legacyImportDemo_2795511684 from "../../../../../packages/component/src/components/table/demo/demo3.js?loadDemo";
import legacyImportDemo_3319800643 from "../../../../../packages/component/src/components/table/demo/demo4.js?loadDemo";
import legacyImportDemo_1451098242 from "../../../../../packages/component/src/components/table/demo/demo5.js?loadDemo";
import legacyImportDemo_1513598273 from "../../../../../packages/component/src/components/table/demo/demo6.js?loadDemo";
import legacyImportDemo_2248242560 from "../../../../../packages/component/src/components/table/demo/demo7.js?loadDemo";
import legacyImportDemo_985188687 from "../../../../../packages/component/src/components/table/demo/demo8.js?loadDemo";
import legacyImportDemo_135470222 from "../../../../../packages/component/src/components/table/demo/demo9.js?loadDemo";
import legacyImportDemo_2571114166 from "../../../../../packages/component/src/components/table/demo/demo10.js?loadDemo";
import legacyImportDemo_765337815 from "../../../../../packages/component/src/components/table/demo/demo11.js?loadDemo";
import legacyImportDemo_1362134516 from "../../../../../packages/component/src/components/table/demo/demo12.js?loadDemo";
import legacyImportDemo_2965731861 from "../../../../../packages/component/src/components/table/demo/demo13.js?loadDemo";
import legacyImportDemo_2095918130 from "../../../../../packages/component/src/components/table/demo/demo14.js?loadDemo";
import legacyImportDemo_1136235603 from "../../../../../packages/component/src/components/table/demo/demo15.js?loadDemo";
import legacyImportDemo_329081712 from "../../../../../packages/component/src/components/table/demo/demo16.js?loadDemo";
import legacyImportDemo_45533585 from "../../../../../packages/component/src/components/table/demo/demo17.js?loadDemo";
import legacyImportDemo_1343335870 from "../../../../../packages/component/src/components/table/demo/demo18.js?loadDemo";
import legacyImportDemo_1378124767 from "../../../../../packages/component/src/components/table/demo/demo19.js?loadDemo";
import legacyImportDemo_3589886581 from "../../../../../packages/component/src/components/table/demo/demo20.js?loadDemo";
import legacyImportDemo_1499609876 from "../../../../../packages/component/src/components/table/demo/demo21.js?loadDemo";
import legacyImportDemo_2783255991 from "../../../../../packages/component/src/components/table/demo/demo22.js?loadDemo";
import legacyImportDemo_1235949142 from "../../../../../packages/component/src/components/table/demo/demo23.js?loadDemo";
import legacyImportDemo_2802672625 from "../../../../../packages/component/src/components/table/demo/demo24.js?loadDemo";
import legacyImportDemo_2778829456 from "../../../../../packages/component/src/components/table/demo/demo25.js?loadDemo";
import legacyImportDemo_947733299 from "../../../../../packages/component/src/components/table/demo/demo26.js?loadDemo";
import * as React from 'react';
export default {
  DemoRenderer__LegacyDemoInstructions,
  InterfaceRenderer__LinkInstructions,
  DemoRenderer__LinkInstructions,
  legacyImportDemo_354296454,
  legacyImportDemo_443464005,
  legacyImportDemo_2795511684,
  legacyImportDemo_3319800643,
  legacyImportDemo_1451098242,
  legacyImportDemo_1513598273,
  legacyImportDemo_2248242560,
  legacyImportDemo_985188687,
  legacyImportDemo_135470222,
  legacyImportDemo_2571114166,
  legacyImportDemo_765337815,
  legacyImportDemo_1362134516,
  legacyImportDemo_2965731861,
  legacyImportDemo_2095918130,
  legacyImportDemo_1136235603,
  legacyImportDemo_329081712,
  legacyImportDemo_45533585,
  legacyImportDemo_1343335870,
  legacyImportDemo_1378124767,
  legacyImportDemo_3589886581,
  legacyImportDemo_1499609876,
  legacyImportDemo_2783255991,
  legacyImportDemo_1235949142,
  legacyImportDemo_2802672625,
  legacyImportDemo_2778829456,
  legacyImportDemo_947733299,
  React
};